export default __webpack_public_path__ + "static/media/Leggings of Dark Malice.1f886690.jpg";